import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { getPatientProfile } from "@/redux/actions/auth";
import type { PatientProfile, ProfileUpdatePayload } from "@/core/types";

import { updateMemberProfile } from "../queryFunctions/updateMemberProfile";

export function useUpdateMemberProfile({
  onSuccess,
  ...options
}: UseMutationOptions<PatientProfile, unknown, ProfileUpdatePayload> = {}) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: updateMemberProfile,
    ...options,
    onSuccess: async (data, variables, context) => {
      dispatch(getPatientProfile(true));
      onSuccess?.(data, variables, context);
    },
  });
}
